<style lang="scss">
.ar {
  width: 100%;
  font-family: 'Roboto', sans-serif;
  border-radius: 16px;
  background-color: #FAFAFA;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.17);
  position: relative;
  box-sizing: content-box;

  &-content {
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-records {
    height: 50px;
    padding-top: 1px;
    overflow-y: auto;
    margin-bottom: 20px;

    &__record {
      width: 320px;
      height: 45px;
      padding: 0 10px;
      margin: 0 auto;
      line-height: 45px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #E8E8E8;
      position: relative;

      &--selected {
        border: 1px solid #E8E8E8;
        border-radius: 24px;
        background-color: #FFFFFF;
        margin-top: -1px;
        padding: 0 34px;
      }
    }
  }

  &-recorder {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__duration {
      color: #AEAEAE;
      font-size: 32px;
      font-weight: 500;
      margin-top: 20px;
      margin-bottom: 16px;
    }

    &__stop {
      position: absolute;
      top: 10px;
      right: -52px;
    }

    &__time-limit {
      position: absolute;
      color: #AEAEAE;
      font-size: 12px;
      top: 128px;
      margin-top: -6px;
    }

    &__records-limit {
      position: absolute;
      color: #AEAEAE;
      font-size: 13px;
      top: 78px;
    }
  }

  &-spinner {
    display: flex;
    height: 30px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 144px;
    z-index: 10;
  }

  &__text {
    color: rgba(84, 84, 84, 0.5);
    font-size: 16px;
  }

  &__blur {
    filter: blur(2px);
    opacity: 0.7;
  }

  &__overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }

  &__upload-status {
    text-align: center;
    font-size: 10px;
    padding: 2px;
    letter-spacing: 1px;
    position: absolute;
    bottom: 0;

    &--success {
      color: green;
    }

    &--fail {
      color: red;
    }
  }

  &__rm {
    cursor: pointer;
    position: absolute;
    width: 6px;
    height: 6px;
    padding: 6px;
    line-height: 6px;
    margin: auto;
    left: 10px;
    bottom: 0;
    top: 0;
    color: rgb(244, 120, 90);
  }

  &__downloader,
  &__uploader {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  &__downloader {
    right: 115px;
  }

  &__uploader {
    right: 85px;
  }
}

@import 'scss/recorder-icons';
@import 'scss/bar-animation';

</style>

<template>
  <div class="ar">
    <div class="ar-content" :class="{'ar__blur': isUploading}">
      <!-- Overlay - mic error -->
      <b-overlay
          :show="isMicError"
          no-wrap
          rounded="sm"
      >
        <template #overlay>
          <div class="text-center">
            <feather-icon icon="MicOffIcon" size="21" />
            <p class="mt-2">{{ $t('RECORDER.Microphone_Permission_Error') }}</p>
            <p>{{ $t('RECORDER.Microphone_Permission_Description') }}</p>
          </div>
        </template>
      </b-overlay>
<!--      <div class="ar__overlay" v-if="isMicError">-->
<!--        <b-alert-->
<!--            variant="primary"-->
<!--            show-->
<!--        >-->
<!--          <div class="alert-body">-->
<!--            <span><strong>Good Morning!</strong> Start your day with some alerts.</span>-->
<!--          </div>-->
<!--        </b-alert>-->
<!--      </div>-->
      
      <div class="ar-recorder">

        <!-- Bar animation -->
        <transition name="fade">
          <div id="bars" v-if="isRecording && !isPause && volume > 0.02">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
          </div>
        </transition>

        <icon-button
            class="ar-icon ar-icon__lg"
            :name="iconButtonType"
            :class="{
            'ar-icon--rec': isRecording,
            'ar-icon--pulse': isRecording && !isPause && volume > 0.02
          }"
            @click.native="toggleRecorder"/>
        <icon-button
            class="ar-icon ar-icon__sm ar-recorder__stop"
            name="stop"
            @click.native="stopRecorder"/>
      </div>

      <!--      <div class="ar-recorder__records-limit" v-if="attempts">Attempts: {{attemptsLeft}}/{{attempts}}</div>-->
      <div class="ar-recorder__duration">{{ recordedTime }}</div>
      <div class="ar-recorder__time-limit" v-if="time">{{ $t('RECORDER.Recording_Limit') }}: {{ time }}m</div>

      <div class="ar-records">
        <div
            class="ar-records__record"
            :class="{'ar-records__record--selected': record.id === selected.id}"
            :key="record.id"
            v-for="(record, idx) in recordList"
            @click="choiceRecord(record)">
          <div
              class="ar__rm"
              v-if="record.id === selected.id"
              @click="removeRecord(idx)">&times;
          </div>
          <div class="ar__text">{{ $t('RECORDER.Recording') }}</div>
          <div class="ar__text">{{ record.duration }}</div>

          <downloader
              v-if="record.id === selected.id && showDownloadButton"
              class="ar__downloader btn-download"
              :record="record"
              :filename="filename"/>

        </div>
      </div>
      <template v-if="mediaRecord._id">
        <p>{{ $t('RECORDER.Audio_From_Media_Library') }}</p>
        <audio-player  :src="mediaRecord.image_path"/>
      </template>
      <template v-else>
        <audio-player  :record="selected"/>
      </template>
    </div>
  </div>
</template>

<script>
// import AudioPlayer from './player'
import Downloader from './downloader'
import IconButton from './icon-button'
import Recorder from '@/libs/recorder/recorder'
import UploaderPropsMixin from '@/mixins/uploader-props'
import {convertTimeMMSS} from '@/libs/recorder/utils'
import { BOverlay } from 'bootstrap-vue';

export default {
  mixins: [UploaderPropsMixin],
  props: {
    // attempts : { type: Number },
    time: {type: Number},

    bitRate: {type: Number, default: 128},
    sampleRate: {type: Number, default: 48000},

    showDownloadButton: {type: Boolean, default: true},
    showUploadButton: {type: Boolean, default: true},

    micFailed: {type: Function},
    beforeRecording: {type: Function},
    pauseRecording: {type: Function},
    afterRecording: {type: Function},
    failedUpload: {type: Function},
    beforeUpload: {type: Function},
    successfulUpload: {type: Function},
    selectRecord: {type: Function},
    mediaRecord: {type: Object}
  },
  data() {
    return {
      isUploading: false,
      recorder: this._initRecorder(),
      recordList: [],
      selected: {},
      uploadStatus: null,
    }
  },
  components: {
    // AudioPlayer,
    Downloader,
    IconButton,
    BOverlay,
  },
  beforeDestroy() {
    this.stopRecorder()
  },
  methods: {
    toggleRecorder() {
      if (!this.isRecording || (this.isRecording && this.isPause)) {
        this.recorder.start()
      } else {
        this.recorder.pause()
      }
    },
    stopRecorder() {
      if (!this.isRecording) {
        return
      }

      this.recorder.stop()
      console.log(this.recorder);
      this.recordList = this.recorder.recordList();

      // CMA
      if (this.recordList.length > 1) {
        this.recordList.shift();
      }
      this.choiceRecord(this.recordList[0]);
    },
    removeRecord(idx) {
      this.recordList.splice(idx, 1)
      this.$set(this.selected, 'url', null)
      // this.$eventBus.$emit('remove-record')
      // CMA
      this.selectRecord(null);
    },
    choiceRecord(record) {
      if (this.selected === record) {
        return
      }
      this.selected = record
      this.selectRecord && this.selectRecord(record)
    },
    _initRecorder() {
      return new Recorder({
        beforeRecording: this.beforeRecording,
        afterRecording: this.afterRecording,
        pauseRecording: this.pauseRecording,
        micFailed: this.micFailed,
        bitRate: this.bitRate,
        sampleRate: this.sampleRate,
        format: this.format
      })
    }
  },
  computed: {
    // attemptsLeft () {
    //   return this.attempts - this.recordList.length
    // },
    iconButtonType() {
      return this.isRecording && this.isPause ? 'mic' : this.isRecording ? 'pause' : 'mic'
    },
    isPause() {
      return this.recorder.isPause
    },
    isRecording() {
      return this.recorder.isRecording
    },
    isMicError() {
      return this.recorder.isMicError
    },
    recordedTime() {
      if (this.time && this.recorder.duration >= this.time * 60) {
        this.stopRecorder()
      }
      return convertTimeMMSS(this.recorder.duration)
    },
    volume() {
      return parseFloat(this.recorder.volume)
    },
  }
}
</script>

